const MODAL = 'EDITOR_MODAL'

const INITIAL_STATE = []

export default (state = INITIAL_STATE, action) => {
  if (action.type === `${MODAL}_PENDING`) {
    const newState = state.concat([action.meta])

    return newState
  }

  if (
    action.type === `${MODAL}_FULFILLED` ||
    action.type === `${MODAL}_REJECTED`
  ) {
    const index = state.indexOf(action.meta)

    const newState = [...state]
    newState.splice(index, 1)

    return newState
  }

  return state
}

// Actions

export const showModal = (modalType, options = {}) => {
  let resolve
  let reject

  let promise = new Promise((resolvePromise, rejectPromise) => {
    resolve = resolvePromise
    reject = rejectPromise
  })

  return {
    type: MODAL,
    meta: { modalType, resolve, reject, options },
    payload: promise,
  }
}

// Selectors

export const getActiveModal = state => {
  const current = state.modals.length - 1

  return state.modals[current]
}

export const getModals = state => {
  return state.editor.modals
}
